import { Component, OnInit } from '@angular/core';
import { MainService } from '../../services/delavci/main.service';
import { HelpdeskService } from '../../services/delavci/helpdesk.service';
import { LoginPartnerService } from '../../services/partner/login-partner/login-partner.service';
import { Router } from '@angular/router';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';
import { Partner } from '../../models/Partner';

@Component({
  selector: 'app-prijavi-napako',
  templateUrl: './prijavi-napako.component.html',
  styleUrls: ['./prijavi-napako.component.css']
})
export class PrijaviNapakoComponent implements OnInit {

  public text: string;
  public zadeva: string;
  public taskId;
  public sessionUserPartner;
  public currentUserPartner: Partner;
  public communicationIdChat;
  constructor(private mainService: MainService, private helpdeskService: HelpdeskService,
              private loginPartnerService: LoginPartnerService, private router: Router, private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.helpdeskService.currentHelpdeskParameters.subscribe(data => {
      this.communicationIdChat = data.communicationIdChat;
      console.log(this.communicationIdChat);
    });

    if (!this.loginPartnerService.currentSessionValue) {
      this.sessionUserPartner = null;
    } else {
      this.sessionUserPartner = this.loginPartnerService.currentSessionValue;
    }
    if (!this.loginPartnerService.currentPartnerValue) {
      this.currentUserPartner = null;
    } else {
      this.currentUserPartner = this.loginPartnerService.currentPartnerValue;
    }
  }

  onTicketSubmit() {
    if (this.text) {
      if (this.loginPartnerService.currentPartnerValue) {
        this.helpdeskService.setTask(this.loginPartnerService.currentSessionValue, this.loginPartnerService.currentPartnerValue,
          this.mainService.currentUserValue, this.zadeva, null, null, this.communicationIdChat).subscribe(data => {
          this.taskId = data.data.id;
          this.setMessages();
        }, error => {
          console.log(error);
          this._snackBar.open('Napaka pri dodajanju novega taska!', '', {
            duration: 2000,
          });
        });
      } else {

      }
    }
  }

  setMessages() {
    this.helpdeskService.setMessages(this.sessionUserPartner, this.taskId, null,
      this.text, this.currentUserPartner, null).subscribe( data => {
        this.router.navigate(['/pregled-helpdeska']);
      }, error => {
        console.log(error);
      });
}

  onBackPressed() {
    this.router.navigate(['/pregled-helpdeska']);
  }
}
